import React from 'react';
import { Box, Typography, useTheme, Grid } from '@mui/material';

const TermsAndConditions = () => {
    const theme = useTheme();

    return (
        <Box>
            <Box
                sx={{
                    backgroundImage:
                        'linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url(/images/desk.jpeg)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'top center',
                    height: '80vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    color: theme.palette.common.white,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                    }}
                ></Box>
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    spacing={3}
                    mt={'8rem'}
                >
                    <Grid item xs={12} md={6}>
                        <Typography variant="h2" textAlign={'center'}>
                            Nick Schader
                        </Typography>
                    </Grid>
                </Grid>
                <Typography variant="h6" textAlign={'center'} sx={{}}>
                    BIBLICALLY-BASED COACHING FOR CHRISTIAN MEN
                </Typography>
            </Box>
            <Box
                sx={{
                    alignItems: 'center',
                    textAlign: 'center',
                    py: 2,
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    width: '100%',
                    backgroundImage:
                        'radial-gradient(at center center, #475B70 0%, #253342 100%)',
                    color: theme.palette.common.white,
                }}
            >
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    spacing={3}
                >
                    <Grid item xs={12} md={2}>
                        <Typography variant="h5">LOVE</Typography>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Typography variant="h5">LEAD</Typography>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Typography variant="h5">PROVIDE</Typography>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Typography variant="h5">PROTECT</Typography>
                    </Grid>
                </Grid>
            </Box>
            <Box
                p={3}
                pt={12}
                display={'flex'}
                justifyContent={'center'}
                sx={{
                    backgroundColor: '#f2ece0',
                    backgroundImage: 'url(/images/bgdots.png)',
                }}
            >
                <Box>
                    <Typography variant="h2">Terms And Conditions</Typography>
                    <br></br>
                    <Typography variant="h5">1. Interpretation</Typography>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        In these Terms and Conditions, the following definitions
                        apply:
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        Renewed Mind Coaching, LLC: a company with its
                        registered office located at Renewed Mind Coaching, 2108
                        N ST, STE, SACRAMENTO, CA 95816.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        Renewed Mind Coaching Product or Services (collectively
                        referred to as ‘the Products and/or Services): the
                        products and services offered by Renewed Mind Coaching.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        Client: The person or company purchasing the Products
                        and/or Services from Renewed Mind Coaching.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        Commencement Date: the date that Renewed Mind Coaching
                        commences provision of the Products and/or Services to
                        the Client.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        Conditions: terms and conditions as amended from time to
                        time in accordance with clause 14.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        Contract: the contract between Renewed Mind Coaching and
                        the Client for the supply of Products and/or Services
                        comprising of the Order and these Conditions.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        Fees: the fees payable by the Client for the supply of
                        the Products and/or Services in accordance with clause
                        4.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        Order: the Client’s order for the Products and/or
                        Services (and any subsequent ongoing Products and/or
                        Services) as set out in the Order Form.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        Order Form: Renewed Mind Coaching’s form which can be
                        completed online, over the phone, or in person, which
                        sets out the Fees and which incorporates these Terms and
                        Conditions.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        Service: the provision of and grant of access to the
                        Renewed Mind Coaching Products and/or Services.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        Privacy Policy: the policy (as updated from time to
                        time) which can be found on the Renewed Mind Coaching
                        Website at www.renewedmind.coach/privacypolicy
                        identifying certain respective rights and obligations in
                        respect of the personal data and privacy under the
                        Contract.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        Authorized Affiliates: the Affiliates of the Client (if
                        any) in respect of those Products and/or Services.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        Authorized Users: the users authorized by the Client to
                        use those Products and/or Services in accordance with
                        the Contract.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        Client Data: all data (in any form) that is provided to
                        Renewed Mind Coaching or uploaded or hosted on any part
                        of any Products and/or Services by the Client or by an
                        Authorized User.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        Client Systems: all software and systems used by or on
                        behalf of the Client, the Authorized Affiliates, any of
                        its or their direct or indirect sub-contractors, or any
                        Authorized User in connection with the provision or
                        receipt any of the Products and/or Services or that the
                        Products and/or Services otherwise link, inter-operate
                        or interface with or utilise (in each case whether
                        directly or indirectly).
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        Protected Data: the information and data referred to in
                        the Privacy Policy.
                    </Typography>
                    <br></br>
                    <Typography variant="h5">2. Basics Of Contract</Typography>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        2.1. The Contract constitutes the entire agreement
                        between the parties. The Client acknowledges that it has
                        not relied on any statement, promise or representation
                        made or given by or on behalf of Renewed Mind Coaching
                        which is not set out in the Contract. These Conditions
                        apply to the Contract to the exclusion of any other
                        terms that the Client seeks to impose or incorporate or
                        which are implied by trade, custom, practice or course
                        of dealing.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        2.2. Any sample materials, descriptive matter or
                        advertising issued by Renewed Mind Coaching, and any
                        descriptions of illustrations contained in Renewed Mind
                        Coaching’s website or brochures, are issued or published
                        for the sole purpose of giving an approximate idea of
                        the Products and/or Services as offered by Renewed Mind
                        Coaching. They will not form part of the Contract or
                        have any contractual force. Renewed Mind Coaching is
                        under a legal duty to supply goods that are in
                        conformity with the Contract.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        2.3. Renewed Mind Coaching has the right to make any
                        changes or alterations to the nature, scope and content
                        of the Products and/or Services, without notice to the
                        Client, at any time, provided these do not affect the
                        nature of the Products and/or Services.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        2.4. Renewed Mind Coaching will supply the Products
                        and/or Services to the Client and Renewed Mind Coaching
                        warrants to the Client that such Products and/or
                        Services have been prepared using reasonable care and
                        skill. Renewed Mind Coaching provides no guarantee that
                        the Products and/or Services will provide any results
                        for the Client.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        2.5. Renewed Mind Coaching will use reasonable endeavors
                        to meet any dates in relation to supporting the Products
                        and/or Services (including but not limited to dates for
                        the Client to attend calls) but any such dates will be
                        provisional only and may be subject to change at the
                        discretion of Renewed Mind Coaching, with no liability
                        attaching to Renewed Mind Coaching in respect of such
                        changes.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        2.6. Renewed Mind Coaching will have the right to make
                        any changes to the support of the Products and/or
                        Services which do not affect their nature or quality
                        (including but not limited to: trainers and teachers,
                        call lengths, session lengths, session frequency,
                        session type, session location, training type, training
                        location, venue location, coach allocated, Facebook
                        group access and content, Skool access and content).
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        2.7. The Client shall (and shall ensure all Authorized
                        Affiliates and Authorized Users shall) at all times
                        comply with all applicable laws relating to the use or
                        receipt of the Products and/or Services, including laws
                        relating to privacy, data protection and use of systems
                        and communications.
                    </Typography>
                    <br></br>
                    <Typography variant="h5">
                        3. Client's Obligations
                    </Typography>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        3.1. The Client will: (a) ensure that all information
                        given by the Client to Renewed Mind Coaching is complete
                        and accurate; (b) co-operate with Renewed Mind Coaching
                        in all matters relating to the Products and/or Services;
                        (c) pay the Fees strictly in accordance with the payment
                        schedule set out in the Order or as otherwise confirmed
                        in writing or over the phone by Renewed Mind Coaching;
                        (d) not use the Products and/or Services or any content,
                        data or information derived from the Client’s use of the
                        Products and/or Services for any purpose other than that
                        which has been expressly authorized under the Contract;
                        (e) not use the Products and/or Services for any
                        unlawful purpose; and (f) permit Renewed Mind Coaching
                        to include information of video footage on its website
                        highlighting any benefits which the Client or Client’s
                        business has obtained from the Products and/or Services
                        and in this regard, the Client hereby grants to Renewed
                        Mind Coaching a royalty-free, non-exclusive perpetual
                        licence to use any intellectual property rights of the
                        Client for this purpose.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        3.2. The Client, for itself and as trustee for any of
                        its directors, employees, agents, Authorized Affiliates,
                        Authorized Users or similar, undertakes to observe the
                        obligations set out in clauses 3.1 to 3.5 (inclusive)
                        and shall fully indemnify Renewed Mind Coaching from and
                        against all loss, damage, costs and claims arising from
                        its failure to adhere to those provisions or otherwise
                        to fulfil its obligations under the Contract.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        3.3. Transmission of storage of any information, data or
                        material in violation of any law is prohibited. This
                        includes, but is not limited to, copyrighted material,
                        material legally judged to be threatening or obscene, or
                        material protected by trade secret and other statute.
                        The Client agrees to indemnify, and hold harmless,
                        Renewed Mind Coaching from any claims resulting from the
                        use of the Products and/or Services which damages the
                        Client or any other parties.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        3.4. The Client is prohibited from transmitting on or
                        through any of Renewed Mind Coaching’s platforms or
                        servers, including but not limited to social media
                        platforms, any material that is (in Renewed Mind
                        Coaching’s sole discretion) unlawful, obscene,
                        threatening, disruptive, abusive, libellous, hateful,
                        that encourages conduct which could constitute a
                        criminal offence, that gives rise to civil liability,
                        that otherwise violates any national or international
                        law, or that involves the transmission of any
                        pornographic or sex-related merchandise or data.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        3.5. The Client shall (and shall ensure all Authorized
                        Affiliates, Authorized Users or similar shall) at all
                        times comply with all applicable laws relating to the
                        use or receipt of the Products and/or Services,
                        including laws relating to privacy, data protection and
                        use of systems and communications.
                    </Typography>
                    <br></br>
                    <Typography variant="h5">4. Fees And Payments</Typography>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        4.1. The Fees for the Products and/or Services are
                        detailed in the Order or any agreement made in writing
                        or over the phone between Renewed Mind Coaching and the
                        Client.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        4.2. The Fees will be paid in full in accordance with
                        the Order, written confirmation from Renewed Mind
                        Coaching, or any agreement made over the phone or with a
                        finance company in accordance with payment for the
                        Products and/or Services.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        4.3. All payments due to Renewed Mind Coaching under the
                        Contract shall be made in full without any deduction or
                        any withholding. The Client will not be entitled to
                        assert any credit, set off or counterclaim against
                        Renewed Mind Coaching against any sum(s) owed.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        4.4. In relation to payment by installments or a payment
                        plan, payment shall be made monthly on the same calendar
                        day as the date of the Order or as otherwise agreed in
                        writing or over the phone between Renewed Mind Coaching
                        and the Client.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        4.5. The Fees will remain payable by the Client
                        notwithstanding any decision to cease using the Products
                        and/or Services and even if the Client does not
                        complete, access, attend or use the entire Products
                        and/or Services.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        4.6. Renewed Mind Coaching shall be entitled to continue
                        processing payments for any monies outstanding using any
                        of the Client’s debit or credit card details previously
                        confirmed to Renewed Mind Coaching.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        4.7. In the event of any payment due to Renewed Mind
                        Coaching becoming overdue and unpaid for more than 20
                        (twenty) days, Renewed Mind Coaching may, at its
                        discretion, suspend or withdraw the provision of the
                        Products and/or Services, without prejudice to any of
                        its other rights as to termination.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        4.8. Save as to the cooling off period set out at clause
                        5, the Contract is non-cancellable and payment will be
                        due by the Client regardless of whether the Products
                        and/or Services are used.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        4.9. The Client acknowledges that they have signed or
                        agreed to the Order through their own choice without
                        coercion or any lawful tactics from Renewed Mind
                        Coaching and are fully responsible for their own
                        decisions.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        4.10. Renewed Mind Coaching reserves the right to
                        instruct third party legal representation should the
                        Client fail to make payment in accordance with these
                        Conditions.
                    </Typography>
                    <br></br>
                    <Typography variant="h5">
                        5. Cooling Off And Right To Cancel
                    </Typography>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        5.1. The Client has a limited period, referred to as
                        ‘cooling off period’, in which they may change their
                        mind and cancel their contract with Renewed Mind
                        Coaching.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        5.2. The cooling off period will begin from the date of
                        the Order and continue for up to 5 days.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        5.3. The Client must give written notice of their
                        cancellation to Renewed Mind Coaching within the 5-day
                        cooling off period.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        5.4. The Client must supply written notice of the
                        request to cancel by email to nick@renewedmind.coach.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        5.5. If the Client exercises their right to cancel, the
                        Product and/or Services will be terminated.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        5.6. If the Client does not request a refund within the
                        cooling off period, the Client is required to complete
                        all remaining payments.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        5.7 Renewed Mind Coaching reserves the right to consider
                        refunds outside of the rescission period. If a client
                        has questions about the agreement outside of the
                        rescission period, they should submit her comments to
                        nick@renewedmind.coach. The Client agrees not to
                        request, advise, file a claim, or seek Client’s bank or
                        credit card company for a chargeback for consideration
                        paid under this Agreement. The Client agrees that any
                        disputes that the Client may have with respect to
                        consideration paid hereunder must be addressed directly
                        between the Client and Renewed Mind Coaching. If a
                        chargeback occurs, the Client shall have materially
                        breached the Terms and Conditions and shall forfeit all
                        remaining services that have not yet been performed
                        under the Terms and Conditions. Renewed Mind Coaching
                        shall have no further obligation to the Client. Further,
                        the amount of the chargeback shall be subject to a
                        finance charge in the amount of one and one-half percent
                        (1.5%) per month until paid in full by the Client.
                        Further, Renewed Mind Coaching shall be entitled to
                        recover from the Client all damages, and reasonable and
                        necessary legal fees, and costs associated with pursuing
                        collection and/or recovery of the amount of the
                        chargeback.
                    </Typography>
                    <br></br>
                    <Typography variant="h5">
                        6. Limitation Of Liability
                    </Typography>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        6.1. Neither party shall be in breach of this Contract
                        nor liable for delay in performing, or failure to
                        perform, any of its obligations under this Contract if
                        such delay or failure result from events, circumstances
                        or causes beyond its reasonable control including but
                        not limited to acts of God; flood; drought; earthquake
                        or other natural disaster; epidemic or pandemic;
                        terrorist attack; civil war; civil commotion or riots;
                        war; threat of or preparation for war; armed conflict;
                        imposition of sanctions; embargo; the breaking off of
                        diplomatic relations; nuclear, chemical or biological
                        contamination or sonic boom; any law or any action taken
                        by a government or public authority, including without
                        limitation imposing an export or import restriction,
                        quota or prohibition; collapse of buildings, fire,
                        explosion or accident; any labor or trade dispute,
                        strikes, industrial action or lockouts; and
                        non-performance by suppliers or subcontractors. In such
                        circumstances the time for performance shall be extended
                        by a period equivalent to the period during which
                        performance of the obligation has been delayed or failed
                        to be performed. If the period of delay or
                        non-performance continues for 6 months, the party not
                        affected may terminate this agreement by giving 14 days'
                        written notice to the affected party.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        6.2. Renewed Mind Coaching will, under no circumstances,
                        be liable to the Client (whether in contract, tort
                        (including negligence), breach of statutory duty, or
                        otherwise), for any indirect or consequential loss,
                        special damages, or any costs or losses attributable to
                        loss of profits or opportunities arising from or in
                        connection with the subject matter of the Contract.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        6.3. The maximum amount of damages payable by Renewed
                        Mind Coaching to the Client in respect of any and all
                        liability (apart from that mentioned above), including
                        liability arising from negligence, under or in
                        connection with the Contract shall not exceed the amount
                        paid by, or on behalf of, the Client to Renewed Mind
                        Coaching for the preceding calendar month or calculated
                        based on 1/12th of the Fees in the preceding 12 months.
                    </Typography>
                    <br></br>
                    <Typography variant="h5">7. Non-Compete</Typography>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        The Client undertakes not to compete or seek to compete,
                        either directly or indirectly or in any other capacity
                        whatsoever, with the business of Renewed Mind Coaching
                        or in the provision of products or services directly
                        competitive with any aspect or part of the Products
                        and/or Services, resulting in actual or anticipated loss
                        to Renewed Mind Coaching, to include as to its
                        reputation.
                    </Typography>
                    <br></br>
                    <Typography variant="h5">
                        8. Intelectual Property Rights
                    </Typography>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        8.1. All intellectual property rights in, arising out
                        of, or in connection with, the Products and/or Services
                        will be owned by Renewed Mind Coaching. Renewed Mind
                        Coaching grants the Client a revocable, non-exclusive
                        royalty-free licence to use such rights only to the
                        extent necessary to allow the Client to benefit from the
                        Products and/or Services but not further or otherwise
                        and no other rights or licences are granted. Any such
                        rights arising from the Client’s use of the Products
                        and/or Services shall accrue to Renewed Mind Coaching
                        and the Client shall be deemed to have assigned any such
                        rights to Renewed Mind Coaching, with Renewed Mind
                        Coaching authorized to act as its agent to execute any
                        such transfer or other documents giving effect to the
                        same.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        8.2. The Client, Authorized Users and Authorized
                        Affiliates may be able to store or transmit Client Data
                        using the Products and/or Services and the Products
                        and/or Services may interact with Client Systems. The
                        Client hereby grants a royalty-free, non-transferable,
                        non-exclusive licence for the Client (and each of its
                        direct and indirect sub-contractors) to use, copy and
                        other otherwise utilise the Client Data and Customer
                        Systems to the extent necessary to perform or provide
                        the Products and/or Services or to exercise or perform
                        Renewed Mind Coaching’s right, remedies and obligation
                        under the Contact.
                    </Typography>
                    <br></br>
                    <Typography variant="h5">
                        9. Data And Information
                    </Typography>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        9.1. Protected Data shall, at all material times, remain
                        the property of the Client or its licensor.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        9.2. Except to the extent Renewed Mind Coaching has
                        direct obligations under data protection and other
                        applicable laws, the Client acknowledges that Renewed
                        Mind Coaching has no control over Protected Data hosted
                        as part of the provision of the Products and/or Services
                        and may not actively monitor or have access to the
                        content of Protected Data. The Client shall ensure (and
                        is exclusively responsible for) the accuracy, quality,
                        integrity and legality of Protected Data and
                        non-personal data and that its use (including use in
                        connection with the Products and/or Services) complies
                        with all applicable laws.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        9.3. If Renewed Mind Coaching becomes aware of any
                        allegation that Protected Data or non-personal data may
                        not comply with the Contract, Renewed Mind Coaching
                        shall have the right to permanently delete or otherwise
                        remove or suspend access to any Protected Data or
                        non-personal data which is suspected of being in breach
                        and/or disclose Protected Data or non-personal data to
                        law enforcement authorities (in each case without the
                        need to consult the Client). Where reasonably
                        practicable and lawful, Renewed Mind Coaching shall
                        notify the Client before taking such action.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        9.4. Renewed Mind Coaching shall have the right to
                        suspend the Products and/or Services at any time, and
                        for any reason, without notice. The Client accepts and
                        acknowledges that the Products and/or Services can be
                        withdrawn or may be unavailable due to technical and
                        other issues, or as a result of updates, maintenance or
                        similar circumstances. If such a suspension or
                        withdrawal is to last more than 30 days, the Client will
                        be notified as to the reason.
                    </Typography>
                    <br></br>
                    <Typography variant="h5">
                        10. Confidentiality And Security Of Data
                    </Typography>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        10.1. Renewed Mind Coaching shall maintain the
                        confidentiality of Protected Data and shall not, without
                        the prior written consent of the Client, and in
                        accordance with the Contract, disclose Protected Data
                        other than as necessary for the performance of the
                        Products and/or Services, the express rights and
                        obligations under the Contract, or as required by law.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        10.2. Renewed Mind Coaching will disclose Protected Data
                        only to those of its officers, employees, agents,
                        contractors and direct and indirect sub-contractors to
                        whom, and to the extent to which, such disclosure is
                        necessary for the purposes contemplated under the
                        Contract or as otherwise reasonably necessary for the
                        provision or receipt of the Products and/or Services.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        10.3. In order to promote and respect the
                        confidentiality of all clients and intellectual property
                        the Client understands that the Products and/or
                        Services, now and in the future, are limited to people
                        who have registered in the respective training. In
                        consideration of, and as a condition for permitting the
                        Client to participate in the Products and/or Services,
                        the Client agrees to not publish, broadcast, disclose,
                        communicate to the public, or assist another to do the
                        same in respect of, the identity, likeness or actual or
                        paraphrased comments of anyone who participates, leads,
                        assists or is otherwise involved in the Products and/or
                        Services.
                    </Typography>
                    <br></br>
                    <Typography variant="h5">11. Warranties</Typography>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        Renewed Mind Coaching gives no warranties of any kind,
                        whether express or implied, for the Products and/or
                        Services it provides under the Contract. Renewed Mind
                        Coaching also disclaims any warranty of merchantability
                        or fitness for a particular purpose. This includes loss
                        of data resulting from delays, non-deliveries,
                        mis-deliveries, or interruptions to the Products and/or
                        Services caused by Renewed Mind Coaching’s negligence or
                        the Client’s errors or omissions. Use of any information
                        obtained via Renewed Mind Coaching is at the Client’s
                        own risk. Renewed Mind Coaching makes no warranty,
                        whether express or implied, as to the accuracy of
                        quality of information obtained through its Products
                        and/or Services.
                    </Typography>
                    <br></br>
                    <Typography variant="h5">
                        12. Assignment And Sub-Contracting
                    </Typography>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        The Client will not, without the prior written consent
                        of Renewed Mind Coaching, assign, transfer, charge,
                        sub-contract or deal in any other manner with all or any
                        of its rights or obligations under the Contract. For the
                        avoidance of doubt, the Client will not share the
                        Products and/or Services or any content, data or
                        information derived from the Client’s use of the
                        Products and/or Services with any third party without
                        the prior written consent of Renewed Mind Coaching,
                        which may be withheld.
                    </Typography>
                    <br></br>
                    <Typography variant="h5">13. Waiver</Typography>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        A waiver of any right under the Contract is only
                        effective if it is in writing and will not be deemed to
                        be a waiver of any subsequent breach or default.
                    </Typography>
                    <br></br>
                    <Typography variant="h5">14. Variation</Typography>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        Except as set out in these Conditions, any variation
                        including the introduction of any additional terms and
                        conditions, to the Contract will only be binding when
                        agreed in writing between the Renewed Mind Coaching and
                        the Client.
                    </Typography>
                    <br></br>
                    <Typography variant="h5">15. Applicable Law</Typography>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        15.1. Any dispute of legal issue arising from the
                        Conditions will be determined by the law of the United
                        States and considered exclusively by the U.S. Courts.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        15.2. Each of the paragraphs referred to in the
                        Conditions shall be severable and distinct from one
                        another and, if at any time, more and more of such
                        provisions become invalid, illegal or enforceable, the
                        validity, legality and enforcability of the terminating
                        paragraphs shall not in any way be affected or impaired
                        by this.
                    </Typography>
                    <br></br>
                    <Typography variant="h5">
                        16. Client Confidentiality Agreement
                    </Typography>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        16.1. The Products and/or Services are limited to people
                        who have registered for the Products and/or Services.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        16.2. The Client will not publish, broadcast, disclose,
                        communicate to the public, or assist another to do the
                        same in respect of, the identity, likeness or actual or
                        paraphrased comments of anyone who participates, leads,
                        assists or is otherwise involved in the Products and/or
                        Services.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        16.3. The Client recognises that any breach of
                        confidentiality may cause Renewed Mind Coaching and/or
                        other clients irreparable and substantial harm even
                        though it may be impossible to ascertain the full
                        monetary extent of their financial loss.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        16.4. Nothing in this Contract is intended to limit the
                        Client from sharing their experience of the Products
                        and/or Services with anyone.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        16.5. Nothing in this Contract is intended to limit
                        Renewed Mind Coaching from sharing results and any
                        testimonials (written or by video) in relation to the
                        Products and/or Services, for any reason (including to
                        promote the business of Renewed Mind Coaching) with
                        anyone by any means.
                    </Typography>
                    <br></br>
                    <Typography variant="h5">17. Complaints</Typography>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        17.1. Renewed Mind Coaching is committed to providing
                        high quality Products and/or Services.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        17.2. Renewed Mind Coaching has a written complaints
                        procedure in place to ensure that all complaints are
                        handled fairly and promptly. A copy of Renewed Mind
                        Coaching’s complaints procedure can be obtained upon
                        request.
                    </Typography>
                    <br></br>
                    <Typography variant="h5">18. General</Typography>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        18.1. Renewed Mind Coaching reserves the right to alter
                        or cancel published dates and change venues without any
                        liability whatsoever.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        18.2. Renewed Mind Coaching reserves the right to make
                        changes to the programs, services, products, speakers or
                        venue should that be necessary.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        18.3. From the date the contract commences, any behavior
                        displayed by the Client that Renewed Mind Coaching deems
                        as disruptive, disrespectful, threatening, abusive or
                        untenable in anyway (to the sole discretion of Renewed
                        Mind Coaching), either in person, via email, via social
                        media or any other forms of means of communication,
                        either directed at Renewed Mind Coaching, Renewed Mind
                        Coaching’s other clients, Renewed Mind Coaching team
                        members or associates, may result in the Client being
                        denied access to all aspects of the Products and/or
                        Services, including but not limited to online support,
                        Facebook groups, Skool groups, live events or coaching
                        calls. All remaining fees would remain payable and any
                        monies for the Products and/or Services will be
                        non-refundable.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        18.4. The Client agrees that Renewed Mind Coaching has
                        not made any promise, guarantee, or other representation
                        with respect to the Client’s future incomes or gains
                        resulting from the provision of the Product and/or
                        Service, and that the Client has not been induced to
                        enter the Contract as a result of any alleged promise,
                        guarantee or representation.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        18.5. Renewed Mind Coaching 100% guarantee for the
                        Client that our method will work if the Client
                        implements everything the way we lay it out for them. If
                        the Client has followed our system and implemented
                        everything the way we lay it out, completing their
                        Business Update form every week so we can support the
                        Client's progress, and the Client can't get prospective
                        clients coming to them then Renewed Mind Coaching will
                        continue to work with the Client until they do.
                    </Typography>
                    <br></br>
                    <Typography variant="body1" maxWidth={'1024px'}>
                        18.6. These Conditions supersede any previous
                        arrangement with your concerning their subject matter.
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default TermsAndConditions;
